import { ComponentPropsWithoutRef } from 'react';
import cx from 'classnames';
import { CSS } from '@stitches/react';

import { styled, SizeType, SizeStyles } from '../../../stitches.config';

const IconContainer = styled('span', {
  display: 'inline-block',
  fontSize: 'inherit',
  variants: {
    size: {
      small: {
        fontSize: '$4',
      },
      medium: {
        fontSize: '$5',
      },
      large: {
        fontSize: '$6',
      },
    } as SizeStyles,
  },
});

export interface IconProps extends ComponentPropsWithoutRef<'span'> {
  className?: string;
  icon: any;
  size?: SizeType;
  css?: CSS;
}

export function Icon(props: IconProps) {
  const { className, icon, size = 'medium', ...restProps } = props;

  return (
    <IconContainer {...restProps} className={cx(className, 'material-symbols-rounded', 'icon')} size={size} aria-hidden>
      {icon}
    </IconContainer>
  );
}

Icon.toString = () => '.icon';

// export { Icon };
